import { jsx as _jsx } from "react/jsx-runtime";
import OCL from 'openchemlib/full';
import { TopicMolecule } from 'openchemlib-utils';
import { createContext, useContext, useEffect, useRef } from 'react';
import { useChartData } from './ChartContext';
const TopicMoleculeContext = createContext({});
export function useTopicMolecule() {
    const context = useContext(TopicMoleculeContext);
    if (!context) {
        throw new Error('Topic Molecule context was not found');
    }
    return context;
}
export function TopicMoleculeProvider({ children, }) {
    const moleculesRef = useRef({});
    const { molecules } = useChartData();
    useEffect(() => {
        for (const { id, molfile } of molecules) {
            const topicMolecule = moleculesRef.current?.[id];
            const molecule = OCL.Molecule.fromMolfile(molfile);
            if (topicMolecule) {
                moleculesRef.current[id] = topicMolecule.fromMolecule(molecule);
            }
            else {
                moleculesRef.current[id] = new TopicMolecule(molecule);
            }
        }
    }, [molecules]);
    return (_jsx(TopicMoleculeContext.Provider, { value: moleculesRef.current, children: children }));
}
